import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message,
  fullScreen = false
}) => {
  const logoSize = {
    sm: 40,
    md: 64,
    lg: 88
  };
  const s = logoSize[size];

  const spinner = (
    <div className="flex flex-col items-center gap-3">
      <div
        style={{
          width: s,
          height: s,
          animation: 'logoPulse 1.5s ease-in-out infinite',
        }}
      >
        <img
          src="/logo192.png"
          alt="DIA9"
          width={s}
          height={s}
          style={{ display: 'block' }}
        />
      </div>
      {message && (
        <div className="text-white text-sm">{message}</div>
      )}
      <style>{`
        @keyframes logoPulse {
          0%, 100% { opacity: 0.4; transform: scale(1); filter: drop-shadow(0 0 0px rgba(0,255,136,0)); }
          50% { opacity: 1; transform: scale(1.08); filter: drop-shadow(0 0 16px rgba(0,255,136,0.6)); }
        }
      `}</style>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-900 via-green-800 to-green-900 flex items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
};
